import {useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import Search from '../../../base_components/Search';
import Select from '../../../base_components/select/Select';
import Table from '../../../base_components/microservice/Table';
import {selectMicroservices} from '../../../features/microservices.slice';
import Context from '../Context';
import image from '../../../assets/frown-solid-cultured-50.png';

import styles from '../../../styles/microservices/MicroserviceList.module.scss';
import Legend from "../../../base_components/microservice/Legend";

function MicroservicesList(props) {
  const microservices = useSelector(selectMicroservices);
  const [gFilteredMicroservices, setGFilteredMicroservices] = useState({});
  const [sFilteredMicroservices, setSFilteredMicroservices] = useState({});
  const [filteredMicroservices, setFilteredMicroservices] = useState({});

  // filter groups using Search and Select
  const [input, setInput] = useState('');
  const [groups, setGroups] = useState({});
  const [placeholder, setPlaceholder] = useState('');

  const context = useContext(Context);

  useEffect(() => {
    let g = {};
    for (let groupName of context.groups) {
      g[groupName] = (groupName === false);
    }
    setGroups(g);
  }, [context.groups]);

  useEffect(() => {  // filter by groups
    const g = Object.keys(groups).filter(group => groups[group]);
    if (g.length === 0) {
      let copy = {...microservices};
      delete copy._persist;
      setGFilteredMicroservices(copy);
      return;
    }

    setGFilteredMicroservices(() => {
      let newGFilteredMicroservices = {};
      for (let id in microservices) {
        if (id === '_persist') continue;

        for (let group of g) {
          if (microservices[id].groups.includes(group)) {
            newGFilteredMicroservices[id] = microservices[id];
          }
        }
      }

      return newGFilteredMicroservices;
    });
  }, [groups, microservices]);

  useEffect(() => {  // filter by search input
    if (input.trim() === '') {
      let copy = {...microservices};
      delete copy._persist;
      setSFilteredMicroservices(copy);
      return;
    }

    const timer = setTimeout(() =>
        setSFilteredMicroservices(() => {
          let newSFilteredMicroservices = {};
          for (let id in microservices) {
            if (id === '_persist') continue;

            if (
              (input.toLowerCase() === 'all types' && microservices[id].fetchers.find(fetcher => Object.keys(fetcher.types).find(type => type === '*'))) ||
              microservices[id].name.toLowerCase().includes(input.toLowerCase()) ||
              microservices[id].fetchers.find(fetcher =>
                fetcher.name.toLowerCase().includes(input.toLowerCase()) ||
                Object.keys(fetcher.types).find(type => type.toLowerCase().replace('_', ' ').includes(input.toLowerCase()))
              )
            ) newSFilteredMicroservices[id] = microservices[id];
          }
          return newSFilteredMicroservices;
        }),
      500
    );
    return () => clearTimeout(timer);
  }, [input, microservices]);

  useEffect(() => {
    setFilteredMicroservices(() => {
      if (Object.keys(sFilteredMicroservices).length === 0 || Object.keys(gFilteredMicroservices).length === 0) return {};

      let newFilteredMicroservices = {};
      for (let id in sFilteredMicroservices) {
        if (Object.keys(gFilteredMicroservices).find(i => i === id)) {
          newFilteredMicroservices[id] = sFilteredMicroservices[id];
        }
      }
      return newFilteredMicroservices;
    });
  }, [sFilteredMicroservices, gFilteredMicroservices]);

  // TODO
  return (
    <div className={styles.microserviceList + ' ' + props.className}>
      <h2>Microservices</h2>
      <Search
        className={styles.search}
        placeholder='Search by microservice name, fetcher name, types'
        input={input}
        setInput={setInput}
      />
      <Select
        className={styles.select}
        placeholder={placeholder || 'Filter by group'}
        setPlaceholder={setPlaceholder}
        items={groups}
        setItems={setGroups}
      />

      <Legend/>

      {Object.keys(filteredMicroservices).length === 0 ? (
        <div className={styles.notFound}>
          <img src={image} alt='Frown solid cultured 50'/>
          <p>Not found</p>
        </div>
      ) : Object.keys(filteredMicroservices).map(microserviceId => (
        <Table
          key={microserviceId}
          id={microserviceId}
          microservice={filteredMicroservices[microserviceId]}
          group={context.defaultGroup}
          context={Context}
        />
      ))}
    </div>
  );
}

export default MicroservicesList;